import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Download } from "lucide-react";
import { useInstall } from "@/lib/pwaInstall";

export function InstallButton({ className = "", testId = "install-app-btn" }) {
  const { t } = useTranslation();
  const { isIOS, isStandalone, hasNativePrompt, promptInstall } = useInstall();

  // Already running as an installed app → nothing to do.
  if (isStandalone) return null;

  const onClick = async () => {
    if (hasNativePrompt) {
      const outcome = await promptInstall();
      if (outcome === "accepted") toast.success(t("install.installed"));
    } else if (isIOS) {
      toast(t("install.ios"), { duration: 8000 });
    } else {
      toast(t("install.desktop"), { duration: 8000 });
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={
        "inline-flex items-center gap-2 text-sm text-foreground/55 hover:text-primary transition-colors w-fit " +
        className
      }
    >
      <span className="w-9 h-9 rounded-full border border-primary/20 bg-primary/[0.06] flex items-center justify-center flex-shrink-0">
        <Download size={15} />
      </span>
      {t("install.menu")}
    </button>
  );
}
